import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select, Divider,
    Popconfirm, Table, Tag, Modal, Form, Switch
} from 'antd';
import {EditOutlined, DeleteOutlined, WechatOutlined} from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
import Backgroung from '../img/seal.png';
import * as url from "url";

const {Title, Text} = Typography;
const {Content} = Layout;
const {Meta} = Card;

const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '提货编号',
        dataIndex: 'pick_pickid',
        key: 'pick_pickid',
    },
    {
        title: '提货单位',
        dataIndex: 'pick_clientname',
        key: 'pick_clientname',
    },
    {
        title: '提货类型',
        dataIndex: 'pick_stock',
        key: 'pick_stock',
    },
    {
        title: '提货量（吨）',
        dataIndex: 'pick_num',
        key: 'pick_num',
    },
    {
        title: '提货车辆',
        dataIndex: 'pick_truck',
        key: 'pick_truck',
    },
    {
        title: '提货时间',
        dataIndex: 'pick_time',
        key: 'pick_time',
    },
    {
        title: '功能',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Print id={record.pick_id}></Print>
            </Space>
        ),
    },
];

const Load = (that, id) => {
    fetch("https://pd.pokemonbye.com:8084/api/getsellclientwxbyclient?client=" + id)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;

                for (let i = 0; i < array.length; i++) {
                    array[i].key = i + 1;
                }
                that.setState({
                    isLoaded: true,
                    list: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Print = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellpickstate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button type="default" size="small" onClick={showPopconfirm}>
                打印
            </Button>
        </Popconfirm>
    );
};
const onGo = (id) => {
    window.location.href = "/pagepurrecord?id=" + id
};

const print = (that) => {/*
    window.document.body.innerHTML = window.document.getElementById('billDetails').innerHTML;
    window.print();
    window.location.reload();*/
    window.open("/pagepurticketprint?name=" + that.state.admin.sysdata_name + "&address=" + that.state.admin.sysdata_address + "&buyer=" + that.state.list.buyer
        + "&id=" + that.state.list.id + "&stock=" + that.state.list.stock + "&value=" + that.state.list.value + "&car=" + that.state.list.car + "&intime=" + that.state.list.intime
        + "&outtime=" + that.state.list.outtime + "&num=" + that.state.list2.assay_num + "&time=" + that.state.list.date)
}

class PagePurTicketTruck extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        this.state = {
            title: "提货票据",
            county: [],
            id: id,
            list: [],
            list2: [],
            admin: []
        };
    }

    componentDidMount() {
        const id = this.state.id;
        if (id) {
            fetch("https://pd.pokemonbye.com:8081/api/getweighttime?time=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        if (array != null && array.length > 0) {
                            for (let i = 0; i < array.length; i++) {
                                array[i].key = i + 1
                                array[i].date = (array[i].outtime).substring(0,10)
                                array[i].value = array[i].value.substring(0, array[i].value.length - 1);
                                array[i].intime = array[i].intime.substring(0, array[i].intime.length - 2);
                                array[i].outtime = array[i].outtime.substring(0, array[i].outtime.length - 2);
                                array[i].weight1 = array[i].weight1.substring(0, array[i].weight1.length - 1);
                                array[i].weight2 = array[i].weight2.substring(0, array[i].weight2.length - 1);
                            }
                            this.setState({
                                isLoaded: true,
                                list: array[0]
                            });
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
            fetch("https://pd.pokemonbye.com:8084/api/getsellbuildassaybydate?date=" + id.substring(0,10))
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        if (array != null && array.length > 0) {
                            for (let i = 0; i < array.length; i++) {
                                array[i].key = i + 1
                            }
                            this.setState({
                                isLoaded: true,
                                list2: array[0]
                            });
                        }else{
                            fetch("https://pd.pokemonbye.com:8084/api/getsellbuildassaynewest")
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                        let array = result.data;
                                        if (array != null && array.length > 0) {
                                            for (let i = 0; i < array.length; i++) {
                                                array[i].key = i + 1
                                            }
                                            console.log(array)
                                            this.setState({
                                                isLoaded: true,
                                                list2: array[0]
                                            });
                                        }
                                    },
                                    // 注意：需要在此处处理错误
                                    // 而不是使用 catch() 去捕获错误
                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                    (error) => {
                                        this.setState({
                                            isLoaded: true,
                                            error
                                        });
                                    }
                                )
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
        fetch("https://pd.pokemonbye.com:8084/api/getsellsysdata")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if (array != null && array.length > 0) {
                        for (let i = 0; i < array.length; i++) {
                            array[i].key = i + 1
                        }
                        this.setState({
                            isLoaded: true,
                            admin: array[0]
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {

        const handleChange = (value) => {
            Load(this, value)
        };
        return (
            <div>
                <Content className="site-layout-background">
                    <div className="site-page-header-ghost-wrapper">
                        <Space
                               id={'billDetails'}
                               direction="vertical"
                               style={{
                                   maxWidth: '300px',
                                   backgroundColor: '#FFFFFF'
                               }}>
                            <div className="background-seal"></div>
                            <PageHeader
                                ghost={false}
                                style={{
                                    backgroundColor: '#00000000'
                                }}
                            >
                                <Title level={4}
                                       style={{
                                           textAlign: 'center',
                                           borderBottom: 'solid 1px'
                                       }}>{this.state.admin.sysdata_name}<br/>产品提货单</Title>
                                <Space direction="vertical"
                                       style={{
                                           textAlign: 'left'
                                       }}>
                                    <Text>销售单位：{this.state.admin.sysdata_name}</Text>
                                    <Text>提货客户：{this.state.list.buyer}</Text>
                                    <Text>提货编号：{this.state.list.id}</Text>
                                    <Text>货品类型：{this.state.list.stock}</Text>
                                    <Text>皮重（吨）：{this.state.list.weight1}</Text>
                                    <Text>毛重（吨）：{this.state.list.weight2}</Text>
                                    <Text>净重（吨）：{this.state.list.value}</Text>
                                    <Text>提货车辆：{this.state.list.car}</Text>
                                    <Text>进厂时间：{this.state.list.intime}</Text>
                                    <Text>出厂时间：{this.state.list.outtime}</Text>
                                </Space>
                                <br/>
                                <br/>
                                <br/>
                                <Title level={4}
                                       style={{
                                           textAlign: 'center',
                                           borderBottom: 'solid 1px'
                                       }}>{this.state.admin.sysdata_name}<br/>产品合格证</Title>
                                <Space direction="vertical"
                                       style={{
                                           textAlign: 'left'
                                       }}>
                                    <Text>产品名称：{this.state.list.stock}</Text>
                                    <Text>检验员：品控室</Text>
                                    <Text>出厂编号：{this.state.list2.assay_num}</Text>
                                    <Text>出厂日期：{this.state.list.date}</Text>
                                    <Text>检测结果评定：经检验本产品符合GB/T1596-2017技术要求。</Text>
                                </Space>
                                <hr/>
                            </PageHeader>
                        </Space>
                        <PageHeader
                            ghost={false}
                            style={{
                                maxWidth: '300px'
                            }}
                        >
                            <Space size={30}>
                                <Button type="primary" onClick={() => print(this)}>补票</Button>
                                <Button disabled>管理</Button>
                                <Button disabled>删除</Button>
                            </Space>
                        </PageHeader>
                    </div>
                </Content>
            </div>
        );
    }
}

export default PagePurTicketTruck;


